const PRODUCT_PATTERNS_BY_SPECIFICITY = [
  { key: "pocket-square", words: ["pocket", "square"] },
  { key: "square-pillow", words: ["square", "pillow"] },
  { key: "lumbar-pillow", words: ["lumbar", "pillow"] },
  { key: "table-runner", words: ["table", "runner"] },
  { key: "hair-scarf", words: ["hair", "scarf"] },
  { key: "face-mask", words: ["face", "mask"] },
  { key: "bow-tie", words: ["bow", "tie"] },
  { key: "necktie", words: ["necktie"] },
  { key: "suspenders", words: ["suspenders"] },
  { key: "robe", words: ["robe"] },
  { key: "pocket-square", words: ["pocket"] },
  { key: "table-runner", words: ["runner"] },
  { key: "table-runner", words: ["table"] },
  { key: "hair-scarf", words: ["scarf"] },
  { key: "suspenders", words: ["suspender"] },
  { key: "face-mask", words: ["mask"] },
  { key: "bow-tie", words: ["bow"] },
  { key: "necktie", words: ["neck"] }
].sort((a, b) => b.words.length - a.words.length);

const LEGACY_SUBSTRING_PATTERNS = [
  { key: "pocket-square", match: "pocket" },
  { key: "bow-tie", match: "bow" },
  { key: "necktie", match: "neck" },
  { key: "table-runner", match: "table" },
  { key: "table-runner", match: "runner" },
  { key: "robe", match: "robe" },
  { key: "square-pillow", match: "square-pillow" },
  { key: "lumbar-pillow", match: "lumbar-pillow" },
  { key: "suspenders", match: "suspenders" },
  { key: "hair-scarf", match: "hair-scarf" },
  { key: "face-mask", match: "mask" }
];

function toWords(value) {
  return value
    .replace(/\.[a-z0-9]+$/, "")
    .split(/[^a-z]+/)
    .filter(Boolean);
}

function containsConsecutiveWords(words, sequence) {
  if (sequence.length > words.length) {
    return false;
  }
  return words.some((word, start) =>
    sequence.every((expected, offset) => words[start + offset] === expected)
  );
}

export function resolveProductKey(value) {
  if (!value) {
    return "";
  }

  const normalized = String(value).toLowerCase();
  const words = toWords(normalized);

  const matched = PRODUCT_PATTERNS_BY_SPECIFICITY.find(product =>
    containsConsecutiveWords(words, product.words)
  );
  if (matched) {
    return matched.key;
  }

  const legacy = LEGACY_SUBSTRING_PATTERNS.find(product =>
    normalized.includes(product.match)
  );
  return legacy ? legacy.key : "";
}

export function resolveProductType(value) {
  return resolveProductKey(value).replace(/-/g, " ");
}



// WEBPACK FOOTER //
// ./src/utils/productTypes.js